var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handbook-matching"},[(_vm.message)?_c('div',[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e(),(_vm.taskId === null)?_c('match-file-attaching',{on:{"attach":_vm.onFileAttach}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }